import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { colours } from "../../../StyleConstants";
import LassoModal from "../../../components/LassoModal";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import React, { useState } from "react";
import { useRevokeAccessMutation } from "../../../api/ducApiSlice";
import { setNewNotification } from "../../common/notificationSlice";
import { useDispatch } from "react-redux";


interface modalProps {
    open: boolean,
    setOpen: Function,
    name: string
    email: string
    id: string
}


const RemoveSubApplicantModal = (props: modalProps) => {


    const [revoke] = useRevokeAccessMutation();
    const dispatch = useDispatch();
    const [loading,setLoading] = useState(false)

    const handleClickCancel = () => {
        props.setOpen(false)

    }

    const handleClickRevoke = () => {
        setLoading(true)
        revoke({ id: props.id }).then((response) => {
            if ("error" in response){
                dispatch(setNewNotification({
                    message: "Unable to revoke access. Please try again later.",
                    type: 'error'
                }))
            }
            else if ("data" in response){
                dispatch(setNewNotification({
                    message: "DUC access for " + response?.data?.fullName + " has been successfully revoked.",
                    type: 'success'
                }))
            }
            else{
                dispatch(setNewNotification({
                    message: "Unable to revoke access. Please try again later.",
                    type: 'error'
                }))
            }
            setLoading(false)
            props.setOpen(false)})
    }

    return (
        <LassoModal open={props.open}>
            {!loading &&
                <Stack gap={4} padding="10px">
                    <Stack flexDirection="row" justifyContent="space-between">
                        <Typography variant="h5" fontWeight="600" color={colours.midnightBlue.blue}>
                            Removing sub-applicant
                        </Typography>
                        <HighlightOffIcon onClick={() => {props.setOpen(false)}}/>
                    </Stack>
                    <Stack gap={1}>
                        <Typography color={colours.midnightBlue.blue} textAlign="center">
                            You are about to remove the following sub-applicant from your group DUC:
                        </Typography>

                        <Typography color={colours.midnightBlue.blue} textAlign="center" fontWeight="600">
                            {props.name}
                        </Typography>

                        <Typography color={colours.midnightBlue.blue} textAlign="center" fontWeight="600">
                            {props.email}
                        </Typography>

                    </Stack>
                    <Stack flexDirection="column" alignSelf="center" gap={2}>
                        <Button variant="outlined" color="error" onClick={handleClickRevoke}>
                            Remove sub-applicant
                        </Button>
                        <Button variant="secondary" onClick={handleClickCancel}>
                            Cancel
                        </Button>
                    </Stack>
                </Stack>}

            {loading &&
                <CircularProgress/>}
        </LassoModal>
    )
}
export default RemoveSubApplicantModal